export default __webpack_public_path__ + "static/faded-tree-b95394d21799bacfb41e98ebe8e0cec0.svg";